export const getNetCash = (cashflow) => (cashflow?.distribution ?? 0) - (cashflow?.contribution ?? 0);
export const concatRates = (rates, terminal) => {
    let result = [];
    if (rates?.length) {
        result = [...rates];
    }
    if (terminal !== undefined) {
        result.push(terminal);
    }
    return result;
};
export const getLatestTvpiValue = (cashflows) => (cashflows && cashflows.length > 0
    ? [...cashflows].sort((a, b) => b.year - a.year)[0]?.tvpi
    : undefined);
